import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EjectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"eject"}/>
}
